import { ProjectCreateData } from "src/app/employee/projects/projects-create/models/project-create-data.model";

export class SetCreateProjectData {
    public static readonly type = "[Projects] Set create project data";

    constructor(public payload: ProjectCreateData) {}
}
